/**
 * A HOC wrapping Material UIs TableCell Component. Used to unify the styles
 * across all of our tables. NOTE: TableCell and HeaderCell are both
 * <TableCell> components, but HeaderCell components belong inside a TableHead,
 * while TableCell belongs inside TableBody.
 */
import { isEmpty } from 'lodash';
import React from 'react';
import { withStyles } from 'tss-react/mui';
import { TableCell } from '@mui/material';

const styles = (theme) => {
  if (isEmpty(theme)) return {};

  return {
    root: {
      fontSize: '10px',
      padding: '2px 0px',
      width: 'auto',
      wordWrap: 'break-word',
      '&:last-child': {
        paddingRight: '14px',
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '0.875rem',
        padding: '6px 16px',
      },
    },
  };
};

export default withStyles((props) => {
  const { classes } = props;
  return <TableCell className={classes.root} {...props} />;
}, styles);
